// "Torna alla lista" che riporta alla pagina da cui si era partiti (es. ordine -> scheda film -> torna all'ordine),
// non sempre alla lista predefinita. App registra ogni pagina visitata; useTornaIndietro risale la storia saltando
// la scheda corrente e le sue altre viste (dettaglio/modifica dello stesso record) e le pagine "nuovo".
import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const storia = [];

export function TracciaNavigazione() {
  const location = useLocation();
  useEffect(() => {
    const pagina = location.pathname + location.search;
    if (storia[storia.length - 1] !== pagina) storia.push(pagina);
    if (storia.length > 50) storia.shift();
  }, [location.pathname, location.search]);
  return null;
}

const sezione = (path) => path.split('/').filter(Boolean).find((p) => !/^(edit|modifica|nuovo|new)$/.test(p)) || '';
const idRecord = (path) => (path.match(/\/(\d+)(?=\/|$)/g) || []).pop()?.slice(1);

function stessoRecord(a, b) {
  const id = idRecord(b);
  return Boolean(id) && idRecord(a) === id && sezione(a) === sezione(b);
}

export function useTornaIndietro(predefinita) {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (location.state?.from) {
      navigate(location.state.from);
      return;
    }
    const corrente = location.pathname;
    for (let i = storia.length - 1; i >= 0; i -= 1) {
      const path = storia[i].split('?')[0];
      if (path === corrente || stessoRecord(path, corrente) || /\/(nuovo|new)(\/|$)/.test(path) || path === '/login') continue;
      navigate(storia[i]);
      return;
    }
    navigate(predefinita);
  }, [navigate, location.pathname, location.state, predefinita]);
}
